/**
 * Общий модуль для всех листалок на сайте.
 * Библиотека загружается по мере необходимости.
 */
itsoftApp.createModule("slidersLibrary", function () {
    /* global Swiper */
    // Локальные переменные
    const module = this;

    const libraries = {
        slider: {
            name: "swiper",
            queue: [],
            started: false,
            loaded: false,
            style: "/assets/scripts/swiper/swiper.min.css",
            script: "/assets/scripts/swiper/swiper.min.js",
            cb: function () {
                Swiper.initedSliders = {};
            }
        }
    }

    const Slider = function (el, sliderSettings, cb, currentSlide) {
        this.el = el;
        this.sliderSettings = sliderSettings;
        this.currentSlide = currentSlide;
        this.sliderContainer = el.querySelector(".swiper-container");
        this.navigation = el.querySelector(".swiper-navigation");
        this.pagination = el.querySelector(".swiper-pagination");
        this.scrollbar = el.querySelector(".swiper-scrollbar");
        this.dataDevice = el.getAttribute("data-destroy-device");
        this.destroyDirection = el.getAttribute("data-destroy-direction");
        this.withoutNavigation = el.hasAttribute("data-without-navigation");
        this.withoutPagination = el.hasAttribute("data-without-pagination");
        this.isInitialized = false;
        this.initializedSlider = null;

        this.init();
    };

    Slider.prototype.init = function () {
        const SLIDER = this;

        Slider.prototype.onWindowResize = function () {
            if (SLIDER.destroyDirection === "from" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() >= +SLIDER.dataDevice) {
                if (SLIDER.isInitialized === true) {
                   SLIDER.destroySlider();
                }
            } else if (SLIDER.destroyDirection === "to" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() <= +SLIDER.dataDevice) {
                if (SLIDER.isInitialized === true) {
                    SLIDER.destroySlider();
                }
            } else {
                if (SLIDER.isInitialized === false) {
                    SLIDER.initSlider();
                }
            }
        };

        Slider.prototype.createSlider = function () {
            if (!SLIDER.sliderSettings) {
                return;
            }

            if (!SLIDER.withoutNavigation && SLIDER.navigation) {
                const prevBtn = SLIDER.navigation.querySelector(".js-prev-btn");
                const nextBtn = SLIDER.navigation.querySelector(".js-next-btn");

                SLIDER.sliderSettings.navigation = {};
                SLIDER.sliderSettings.navigation.prevEl = prevBtn;
                SLIDER.sliderSettings.navigation.nextEl = nextBtn;
            }

            if (!SLIDER.withoutPagination && SLIDER.pagination) {
                if (!SLIDER.sliderSettings.pagination) {
                    SLIDER.sliderSettings.pagination = {};
                }
                SLIDER.sliderSettings.pagination.el = SLIDER.pagination;

                if (SLIDER.pagination.classList.contains("js-pagination-dots")) {
                    SLIDER.sliderSettings.pagination.type = "bullets";
                    SLIDER.sliderSettings.pagination.clickable = true;
                } else if (SLIDER.pagination.classList.contains("js-pagination-progress")) {
                    SLIDER.sliderSettings.pagination.type = "progressbar";
                    SLIDER.sliderSettings.pagination.clickable = true;
                } else if (SLIDER.pagination.classList.contains("js-pagination-custom")) {
                    SLIDER.sliderSettings.pagination.clickable = true;
                    SLIDER.sliderSettings.pagination.renderBullet = function () {
                        return `
                            <span class="swiper-pagination-bullet">
                                <svg viewBox="0 0 48 48" fill="none">
                                    <circle cx="24" cy="24" r="22.5" stroke="currentColor" stroke-width="3"/>
                                </svg>
                            </span>
                        `;
                    }
                } else {
                    SLIDER.sliderSettings.pagination.type = "fraction";
                    SLIDER.sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
                        return "<span class='" + currentClass + "'></span>" +
                              "/" +
                              "<span class='"+ totalClass + "'></span>";
                    };
                }
            }

            if (SLIDER.dataDevice) {
                SLIDER.onWindowResize();
                itsoftApp.modules.windowResize.addEvent(SLIDER.onWindowResize);
            } else {
                SLIDER.initSlider();
            }
        };

        new itsoftApp.modules.startLoad.callback(this.createSlider, libraries.slider);
    }

    Slider.prototype.destroySlider = function () {
        this.initializedSlider.destroy(false, true);
        this.initializedSlider = undefined;
        this.isInitialized = false;
    };

    Slider.prototype.initSlider = function () {
        this.initializedSlider = new Swiper(this.sliderContainer, this.sliderSettings);

        if (this.initializedSlider) {
            if (this.currentSlide) {
                this.initializedSlider.slideTo(+this.currentSlide);
            }

            this.isInitialized = true;
        }
    };

    module.callback = Slider;
});